/** @format */

import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import { Formik, Form, FieldArray } from "formik";
import TextField from "@mui/material/TextField";

function FieldArrayComponent({
  initialValues,
  setValues,
  setBalanceDue,
  invoiceValue,
  invoiceCurrency,
}) {
  console.log(initialValues);
  return (
    <>
      <Typography sx={{ my: 1 }}>TT Advance Details</Typography>
      <Formik
        initialValues={{ advancePercentages: initialValues }}
        onSubmit={(values) => {
          console.log(values);
        }}>
        {({ values }) => (
          <>
            <Form>
              <FieldArray
                name="advancePercentages"
                render={(arrayHelpers) => (
                  <>
                    {values.advancePercentages?.map((percentage, index) => {
                      return (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 1,
                          }}>
                          <TextField
                            margin="normal"
                            id={`advancePercentages.${index}`}
                            label="Percentage"
                            name={`advancePercentages.${index}`}
                            value={percentage}
                            onChange={arrayHelpers.form.handleChange}
                            type="number"
                            inputProps={{
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                          {percentage !== 0 && invoiceValue !== 0 && (
                            <Typography>
                              {(invoiceValue * percentage) / 100}
                            </Typography>
                          )}
                          {percentage !== 0 && invoiceCurrency && (
                            <Chip label={invoiceCurrency} color="primary" />
                          )}
                          {index === 0 ? null : (
                            <IconButton
                              aria-label="delete"
                              onClick={() => arrayHelpers.remove(index)}>
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </Box>
                      );
                    })}
                    <Button
                      color="secondary"
                      onClick={() => arrayHelpers.push(0)}>
                      Add Another Field
                    </Button>
                  </>
                )}
              />
            </Form>
            {(() => {
              let sum = values.advancePercentages?.reduce((x, y) => {
                return x + y;
              }, 0);
              console.log(sum);
              let balanceDue = Math.abs(
                invoiceValue - (sum * invoiceValue) / 100
              );
              console.log(balanceDue);
              setBalanceDue(balanceDue);
              setValues(values.advancePercentages)
              return (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 1,
                    }}>
                    <Typography>
                      Balance Due : 
                      <Typography variant="spam" color="primary">
                        {" "+ balanceDue}
                      </Typography>
                    </Typography>
                    {invoiceCurrency && (
                      <Chip
                        color="primary"
                        variant="outlined"
                        label={invoiceCurrency}
                      />
                    )}
                  </Box>
                </>
              );
            })()}
          </>
        )}
      </Formik>
    </>
  );
}

export default FieldArrayComponent;
